var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-treeview',{staticClass:"sitamenue",attrs:{"selectable":"","items":_vm.items,"return-object":""},on:{"input":_vm.onInput_buildQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }